@import "config";

$logo-reduced-width: 40px;

.title {
	@include flex(row, center, unset);
	color: var(--color-light-l2);
	font-weight: $font-weight-bold;
	line-height: $font-line-heights-far;
}

@mixin openMenu {
	width: max-content;
	min-width: $main-nav-opened-width;

	[class*="icon-container"] {
		margin-right: $spacing-inline-nano;
	}

	.title {
		justify-content: start;
		padding-left: $spacing-inline-xxxs;
	}

	.logoContainer {
		position: relative;

		.logoExpanded {
			display: block;
		}

		.logoMinified {
			display: none;
		}
	}
}

@mixin closeMenu {
	.logoContainer {
		max-width: 70px;

		.logoExpanded {
			display: none;
		}

		.logoMinified {
			display: block;
		}
	}
}

.divider {
	width: calc(100% - $spacing-inline-xxs);
	margin: 0 auto;
	display: block;
}

.navContainer {
	min-width: $main-nav-collpased-width;
	width: $main-nav-collpased-width;
	box-sizing: border-box;
	transition: all ease 0.1s;
	height: 100vh;
	z-index: 500;
	position: relative;
	background-color: var(--color-primary-pure);
	padding-top: $spacing-inline-xxxs;

	.navMenu {
		@include customScroll;
		@include flex(column, unset, unset);
		margin: 0;
		list-style-type: none;
		height: calc(100% - 92px);
		padding: $spacing-inset-nano;

		.divider {
			width: 100%;
		}
	}

	.logoContainer {
		.logoMinified {
			padding-block: $spacing-stack-nano;
			svg {
				max-height: 18px;
			}
		}
	}

	@include for-phone-only {
		position: absolute;
		left: -$main-nav-opened-width;
		top: 0;
	}

	&.forceOpen {
		left: 0;
		@include openMenu;

		position: relative;

		.overlay {
			display: block;
			position: absolute;
			width: calc(100vw - 100%);
			height: 100vh;
			top: 0;
			left: 100%;
			right: 0;
			bottom: 0;
			background-color: var(--color-dark-d1);
			opacity: 0.6;
		}
	}

	&:not(.forceOpen) {
		@include closeMenu;

		.overlay {
			display: none;
		}
	}

	.divider {
		margin: $spacing-stack-nano auto;
		width: calc(100% - $spacing-inline-xs);
	}

	.logoContainer {
		@include flex(row, center, center);

		svg {
			width: 44px;
		}
	}

	@media print {
		display: none;
	}
}

.divider {
	border: none;
	width: 100%;
	border-top: 1.5px solid var(--color-primary-light);
}

.patternContainer {
	left: 0;
	bottom: 0;
	width: 100%;
	z-index: -1;
	position: absolute;
	overflow: hidden;
	transition: width ease-in 0.1s;

	.pattern {
		top: 6px;
		position: relative;

		[class*="svg-group"] {
			mix-blend-mode: multiply;
			fill: var(--color-primary-pure);
		}
	}

	&:after {
		left: 0;
		bottom: 0;
		width: 100%;
		content: "";
		height: 256px;
		display: block;
		position: absolute;
		background: linear-gradient(
			180deg,
			var(--color-primary-pure) 0%,
			rgba(0, 0, 0, 0) 100%
		);
	}
}
